import {
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { FormPopupComponent } from '../../../../../../../../components';
import { ComplianceFormComponent } from '../../../compliance-form/compliance-form.component';
import { AppointmentComplianceDto, AppointmentsClient, UpdateAppointmentComplianceCommand } from '@services';
import notify from 'devextreme/ui/notify';

@Component({
    selector: 'edit-compliance-form',
    imports: [FormPopupComponent, ComplianceFormComponent],
    templateUrl: './edit-compliance-form.component.html',
})
export class EditComplianceFormComponent {
    @ViewChild(ComplianceFormComponent, { static: false }) editNewForm: ComplianceFormComponent;

    @Input() appointmentNumber!: string;
    @Input() isReadOnly = false;
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onSave = new EventEmitter();

    private appointmentsClient = inject(AppointmentsClient);

    formData: AppointmentComplianceDto = {} as AppointmentComplianceDto;

    loadAppointmentByNumber = (number: string) => {
        this.appointmentsClient.getAppointmentCompliance(number).subscribe({
            next: (data: AppointmentComplianceDto) => {
                this.formData = data;
            },
            error: () => {},
        });
    };

    onPopupSaveClick = () => {
        let formData = this.editNewForm.getData();

        let updateCommand = new UpdateAppointmentComplianceCommand({
            number: this.appointmentNumber,            
            ...formData,
        });

        this.appointmentsClient.updateAppointmentCompliance(updateCommand).subscribe({
            next: async () => {
                this.visible = false;
                this.visibleChange.emit(this.visible);
                this.onSave.emit();
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg) => {
                    notify(
                        {
                            message: errMsg.message,
                            type: 'error',
                            displayTime: 5000,
                        },
                        {
                            position: 'bottom right',
                            direction: 'up-push',
                        },
                    );
                });
            },
        });
    };

    onVisibleChange(visible: boolean) {
        this.visibleChange.emit(visible);
    }

    protected onOpen() {
        this.loadAppointmentByNumber(this.appointmentNumber);
    }
}